<template>
    <b-button 
        v-if="$temAcessoView('DESP-GERAIS-DEMAN-01') && statusAprovacao"
        class="ml-2"
        variant="danger" 
        @click.stop="confirmarReprovacao()"
    >
        <span> <i class="fa fa-times-circle mr-2"></i> Reprovar </span>
    </b-button>
</template>

<script>
import DespesasServicos from './DespesasServicos'
import { StatusDespesa } from '../../componentes/despesas/StatusDespesa'

export default {
    props: {
        despesa: {
            type: Object
        }
    },

    methods: {
        confirmarReprovacao() {
            this.$swal({
                title: 'Reprovar despesa',
                html: `Confirma a reprovação da despesa?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                input: 'textarea',
                inputPlaceholder: 'Informe a justificativa da reprovação',
                inputValidator: value => {
                    if (!value) {
                        return 'A justificativa da reprovação é obrigatória'
                    }
                }
            }).then(result => {
                if (result.value) {
                    this.reprovar(result.value)
                }
            })
        },

        reprovar(justificativa) {
            this.$store.dispatch('addRequest')
            let justificativaDto = {
                'justificativa': justificativa
            }
            DespesasServicos.reprovar(this.despesa.despesaId, justificativaDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Despesa reprovada com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('obterDespesa')
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    computed: {
        statusAprovacao() {
            return this.despesa != null
               && this.despesa.statusId == StatusDespesa.AGUARDANDO_APROVACAO_DEMANDANTE
        }
    }
}

</script>